import React from 'react';
import { Box, Link, Typography, IconButton, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu'
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { logoTransparent } from '../../assets';
import { useNavigate } from 'react-router-dom';
import { FlipCard } from '../Animations';

const Navbar = ({sx}) => {
  const links = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'Career', path: '/career' },
    { name: 'Contact Us', path: '/contact' },
  ];

  const Links = ({links}) => {
    return (
      <>
      {links.map((link, index) => (
        <Box
          sx={{
            padding:'1rem',
            textAlign:'center',
            alignItems:'center',
            alignContent:'center'
          }}
        >
          <Link
              href={link.path}
              sx={{
                textDecoration:'none',
                color:'#fefefe'
              }}
          >
              <Typography
                sx={{
                  fontSize:'1rem',
                  fontFamily:'Gotham',
                  fontWeight:'normal',
                  transition: 'transform 0.5s ease-in-out', // transition smoothing
                  '&:hover':{
                    transform:'scale(1.3)',
                    color:'blue',
                  },
                  '@media (max-width:768px)':{
                  }
                }}
              >
                {link.name}
              </Typography>
          </Link>  
        </Box>
      ))}
      </>
    )
  }

  const MenuPopover = ({links}) => {
    const navigate = useNavigate();
    return (
      <PopupState variant='popover' popupId='popup'>
        {(popupState) => (
          <>
            <IconButton {...bindTrigger(popupState)}
              sx={{
                display:'none',
                '@media screen and (max-width: 762px)':{
                  display:'block'
                }
              }}
            >
              <MenuIcon fontSize='large' sx={{ color:'#fefefe'}}/>
            </IconButton>
            <Menu 
              {...bindMenu(popupState)} 
              disableScrollLock
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }} // Position the menu relative to the trigger
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }} // Ensure the menu opens within the window
              PaperProps={{
                style: {
                  maxHeight: '50vh', // Limit the height of the menu
                  overflow: 'auto', // Enable scrolling if the menu overflows
                },
              }}  
            >
              {links.map((item, index) => (
                <MenuItem 
                  onClick={() => {
                    popupState.close();
                    navigate(item.path);
                  }}
                >{item.name}</MenuItem>
              ))}
            </Menu>
          </>
        )}
      </PopupState>
    )
  }


  return (
    <Box
      sx={{
        ...sx
      }}
    >
      <Box
        sx={{
          display:'flex',
          flexDirection:'row',
          width:'100%',
        }}
      >

        <Box
          sx={{
            display:'flex',
            flexDirection:'row',
            width:'100%',
            justifyContent:'space-between',
          }}
        >

          <Box // logo && Brand Name
            sx={{
              display:'flex',
              flexDirection:'row',
              padding:'1rem',
              alignItems:'center',
              width:'20%'
            }}
          >
            <Box // logo
              sx={{
                width:'3rem'
              }}
            >
              <FlipCard>
                <Box
                  component='img'
                  src={logoTransparent}
                  sx={{
                    width: '3rem',
                    display:'flex'
                  }}
                />
              </FlipCard>
            </Box>
            <Box>
              <Typography
                variant='h1'
                sx={{
                  fontSize:'1.5rem',
                  fontFamily:"ITC Avant Garde Gothic",
                  textTransform:'Uppercase',
                  fontWeight:'1000',
                  alignContent:'center',
                  alignItems:'center',
                  letterSpacing:'0.5rem',
                  textAlign:'center',
                  lineHeight:'4rem',
                  fontStretch:'expanded',
                  marginX:'1rem',
                  color:'#fefefe'
                }}
              >
                Pangu
              </Typography>
            </Box>
          </Box>

          <Box //Menu
            sx={{
              display:'flex',
              flexDirection:'row',
              width:'60%',
              justifyContent:'space-evenly',
              '@media screen and (max-width:762px)':{
                display:'none'
              }
            }}
          >
            <Links links={links}/>
          </Box>

          <Box //menu small screen
            sx={{
              width:'20%',
              alignContent:'center',
              marginX:'0',
              '@media screen and (max-width:762px)':{
                display:'block'
              }
            }}
          >
            
            <MenuPopover links={links}
            />
          </Box>
        </Box>

      </Box>
    </Box>
  );
};

export default Navbar;
